<template>
    <section class="section section-sponsors">
        <div class="container grid-lg">
            <div class="sponsorship">
                <div class="section-title h2">
                    <div class="h2">
                        <h3 class="h2"><strong>Sponsors</strong></h3>
                        <div class="subtitle">
                            We offer <span class="highlight"><strong>diverse range</strong></span> of sponsorship packages. Contact us for more information.
                        </div>
                    </div>
                </div>
                <div>
                    <router-link to="/become-a-sponsor/" target="_blank" class="btn">
                        Sponsorship packages
                    </router-link>
                </div>
            </div>

            <div class="divider divider-gradient"></div>

            <div class="sponsor-list">
                <p class="text-muted mb-0">
                    Our Partners
                </p>
                <div class="columns">
                    <div class="column col-6 col-sm-6">
                        <a href="https://design.google/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-google.svg">
                        </a>
                    </div>
                    <div class="column col-6 col-sm-6">
                        <a href="https://aws-amplify.github.io/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-amazon.svg">
                        </a>
                    </div>
                </div>
            </div>

            <div class="sponsor-list">
                <p class="text-muted mb-0">
                    Our Gold sponsors
                </p>
                <div class="columns">
                    <div class="column col-4 col-sm-6">
                        <a href="https://www.teamwolfgang.com/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-wolfgang.svg">
                        </a>
                    </div>
                    <div class="column col-4 col-sm-6">
                        <a href="https://www.idshop.si/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-idshop.svg">
                        </a>
                    </div>
                    <div class="column col-4 col-sm-6">
                        <a href="https://www.edreamsodigeo.com/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-edreams.svg">
                        </a>
                    </div>
                </div>
            </div>

            <div class="sponsor-list">
                <p class="text-muted mb-0">
                    Our Patrons
                </p>
                <div class="columns">
                    <div class="column col-3 col-sm-4">
                        <a href="https://www.strava.com/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-strava.svg">
                        </a>
                    </div>
                    <div class="column col-3 col-sm-4">
                        <a href="https://deliveroo.co.uk/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-deliveroo.svg">
                        </a>
                    </div>
                    <div class="column col-3 col-sm-4">
                        <a href="https://wework.com/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-wework.svg">
                        </a>
                    </div>
                    <div class="column col-3 col-sm-4">
                        <a href="http://stickermule.com/supports/addc19" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-stickermule.svg">
                        </a>
                    </div>
                </div>
            </div>

            <div class="sponsor-list">
                <p class="text-muted mb-0">
                    Our Media Partners
                </p>
                <div class="columns">
                    <div class="column col-3 col-sm-4">
                        <a href="https://www.sketchapp.com/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-sketch.svg">
                        </a>
                    </div>
                    <div class="column col-3 col-sm-4">
                        <a href="https://mobileera.rocks/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-mobileera.svg">
                        </a>
                    </div>
                    <div class="column col-3 col-sm-4">
                        <a href="https://digitalagencynetwork.com/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-dan.svg">
                        </a>
                    </div>
                    <div class="column col-3 col-sm-4">
                        <a href="https://www.techevents.online/" target="_blank">
                            <img class="img-responsive" src="../assets/img/sponsors/brand-tech-events.svg">
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
    export default {
        name: 'Sponsors',
    };
</script>

<style scoped>

</style>
